import whichPolygon from 'which-polygon';
import rawBorders from './data/borders.json';
export let borders = rawBorders;
let whichPolygonGetter = {};
let featuresByCode = {};
let idFilterRegex = /\bThe\b|\bthe\b|\band\b|\bof\b|[-_ .,()&[\]/]/g;
let levels = [
  'subterritory',
  'territory',
  'country',
  'intermediateRegion',
  'subregion',
  'region',
  'union',
  'world'
];
loadDerivedDataAndCaches(borders);
function loadDerivedDataAndCaches(borders) {
  let identifierProps = ['iso1A2', 'iso1A3', 'm49', 'wikidata', 'emojiFlag', 'nameEn'];
  let geometryFeatures = [];
  for (let i in borders.features) {
    let feature = borders.features[i];
    feature.properties.id = feature.properties.iso1A2 || feature.properties.m49;
    loadM49(feature);
    loadIsoStatus(feature);
    loadLevel(feature);
    loadGroups(feature);
    loadRoadSpeedUnit(feature);
    loadDriveSide(feature);
    loadFlag(feature);
    cacheFeatureByIDs(feature);
    if (feature.geometry) geometryFeatures.push(feature);
  }
  for (let i in borders.features) {
    let feature = borders.features[i];
    feature.properties.groups.sort(function(groupID1, groupID2) {
      return (
        levels.indexOf(featuresByCode[groupID1].properties.level) -
        levels.indexOf(featuresByCode[groupID2].properties.level)
      );
    });
    loadMembersForGroupsOf(feature);
  }
  let geometryOnlyCollection = {
    type: 'RegionFeatureCollection',
    features: geometryFeatures
  };
  whichPolygonGetter = whichPolygon(geometryOnlyCollection);
  function loadGroups(feature) {
    let props = feature.properties;
    if (!props.groups) {
      props.groups = [];
    }
    if (props.country) {
      props.groups.push(props.country);
    }
    if (props.m49 !== '001') {
      props.groups.push('001');
    }
  }
  function loadM49(feature) {
    let props = feature.properties;
    if (!props.m49 && props.iso1N3) {
      props.m49 = props.iso1N3;
    }
  }
  function loadIsoStatus(feature) {
    let props = feature.properties;
    if (!props.isoStatus && props.iso1A2) {
      props.isoStatus = 'official';
    }
  }
  function loadLevel(feature) {
    let props = feature.properties;
    if (props.level) return;
    if (!props.country) {
      props.level = 'country';
    } else if (props.isoStatus === 'official') {
      props.level = 'territory';
    } else {
      props.level = 'subterritory';
    }
  }
  function loadRoadSpeedUnit(feature) {
    let props = feature.properties;
    if (props.roadSpeedUnit === undefined && props.iso1A2 && props.iso1A2 !== 'EU') {
      props.roadSpeedUnit = 'km/h';
    }
  }
  function loadDriveSide(feature) {
    let props = feature.properties;
    if (props.driveSide === undefined && props.iso1A2 && props.iso1A2 !== 'EU') {
      props.driveSide = 'right';
    }
  }
  function loadFlag(feature) {
    if (!feature.properties.iso1A2) return;
    let flag = feature.properties.iso1A2.replace(/./g, function(char) {
      return String.fromCodePoint(char.charCodeAt(0) + 127397);
    });
    feature.properties.emojiFlag = flag;
  }
  function loadMembersForGroupsOf(feature) {
    let featureID = feature.properties.id;
    let standardizedGroupIDs = [];
    for (let j in feature.properties.groups) {
      let groupID = feature.properties.groups[j];
      let groupFeature = featuresByCode[groupID];
      standardizedGroupIDs.push(groupFeature.properties.id);
      if (groupFeature.properties.members) {
        groupFeature.properties.members.push(featureID);
      } else {
        groupFeature.properties.members = [featureID];
      }
    }
    feature.properties.groups = standardizedGroupIDs;
  }
  function cacheFeatureByIDs(feature) {
    for (let k in identifierProps) {
      let prop = identifierProps[k];
      let id = prop && feature.properties[prop];
      if (id) {
        id = id.replace(idFilterRegex, '').toUpperCase();
        featuresByCode[id] = feature;
      }
    }
    if (feature.properties.aliases) {
      for (let j in feature.properties.aliases) {
        let alias = feature.properties.aliases[j].replace(idFilterRegex, '').toUpperCase();
        featuresByCode[alias] = feature;
      }
    }
  }
}
function locArray(loc) {
  if (Array.isArray(loc)) {
    return loc;
  } else if (loc.coordinates) {
    return loc.coordinates;
  }
  return loc.geometry.coordinates;
}
function smallestFeature(loc) {
  let query = locArray(loc);
  let featureProperties = whichPolygonGetter(query);
  if (!featureProperties) return null;
  return featuresByCode[featureProperties.id];
}
function countryFeature(loc) {
  let feature = smallestFeature(loc);
  if (!feature) return null;
  let countryCode = feature.properties.country || feature.properties.iso1A2;
  return featuresByCode[countryCode];
}
function featureForLoc(loc, opts) {
  if (opts && opts.level && opts.level !== 'country') {
    let features = featuresContaining(loc);
    let targetLevel = opts.level;
    let targetLevelIndex = levels.indexOf(targetLevel);
    if (targetLevelIndex === -1) return null;
    for (let i in features) {
      let feature = features[i];
      if (
        feature.properties.level === targetLevel ||
        levels.indexOf(feature.properties.level) > targetLevelIndex
      ) {
        return feature;
      }
    }
    return null;
  }
  return countryFeature(loc);
}
function featureForID(id) {
  let stringID;
  if (typeof id === 'number') {
    stringID = id.toString();
    if (stringID.length === 1) {
      stringID = '00' + stringID;
    } else if (stringID.length === 2) {
      stringID = '0' + stringID;
    }
  } else {
    stringID = id.replace(idFilterRegex, '').toUpperCase();
  }
  return featuresByCode[stringID] || null;
}
function smallestOrMatchingFeature(query) {
  if (typeof query === 'object') {
    return smallestFeature(query);
  }
  return featureForID(query);
}
export function feature(query, opts) {
  if (typeof query === 'object') {
    return featureForLoc(query, opts);
  }
  return featureForID(query);
}
export function iso1A2Code(query, opts) {
  let match = feature(query, opts);
  if (!match) return null;
  return match.properties.iso1A2 || null;
}
export function iso1A3Code(query, opts) {
  let match = feature(query, opts);
  if (!match) return null;
  return match.properties.iso1A3 || null;
}
export function iso1N3Code(query, opts) {
  let match = feature(query, opts);
  if (!match) return null;
  return match.properties.iso1N3 || null;
}
export function m49Code(query, opts) {
  let match = feature(query, opts);
  if (!match) return null;
  return match.properties.m49 || null;
}
export function wikidataQID(query, opts) {
  let match = feature(query, opts);
  if (!match) return null;
  return match.properties.wikidata;
}
export function emojiFlag(query, opts) {
  let match = feature(query, opts);
  if (!match) return null;
  return match.properties.emojiFlag || null;
}
export function featuresContaining(query, strict) {
  let feature = smallestOrMatchingFeature(query);
  if (!feature) return [];
  let features = [];
  if (!strict || typeof query === 'object') {
    features.push(feature);
  }
  let properties = feature.properties;
  for (let i in properties.groups) {
    let groupID = properties.groups[i];
    features.push(featuresByCode[groupID]);
  }
  return features;
}
export function featuresIn(id, strict) {
  let feature = featureForID(id);
  if (!feature) return [];
  let features = [];
  if (!strict) {
    features.push(feature);
  }
  let properties = feature.properties;
  if (properties.members) {
    for (let i in properties.members) {
      let memberID = properties.members[i];
      features.push(featuresByCode[memberID]);
    }
  }
  return features;
}
export function aggregateFeature(id) {
  let features = featuresIn(id, false);
  if (features.length === 0) return null;
  let aggregateCoordinates = [];
  for (let i in features) {
    let feature = features[i];
    if (
      feature.geometry &&
      feature.geometry.type === 'MultiPolygon' &&
      feature.geometry.coordinates
    ) {
      aggregateCoordinates = aggregateCoordinates.concat(feature.geometry.coordinates);
    }
  }
  return {
    type: 'Feature',
    properties: features[0].properties,
    geometry: {
      type: 'MultiPolygon',
      coordinates: aggregateCoordinates
    }
  };
}
export function isIn(query, bounds) {
  let queryFeature = smallestOrMatchingFeature(query);
  let boundsFeature = featureForID(bounds);
  if (!queryFeature || !boundsFeature) return false;
  if (queryFeature.properties.id === boundsFeature.properties.id) return true;
  return queryFeature.properties.groups.indexOf(boundsFeature.properties.id) !== -1;
}
export function isInEuropeanUnion(query) {
  return isIn(query, 'EU');
}
export function driveSide(query) {
  let feature = smallestOrMatchingFeature(query);
  return (feature && feature.properties.driveSide) || null;
}
export function roadSpeedUnit(query) {
  let feature = smallestOrMatchingFeature(query);
  return (feature && feature.properties.roadSpeedUnit) || null;
}
export function callingCodes(query) {
  let feature = smallestOrMatchingFeature(query);
  return (feature && feature.properties.callingCodes) || [];
}
